module.exports = __webpack_public_path__ + "img/purple-3-squiggly-open.41c9c494.svg";